import MarkdownRenderer from './MarkdownRenderer';
import type { LighthouseAudit } from '@/app/PageSpeed/api/types/analysisApiTypes';

type Props = { audit: LighthouseAudit };

const NumericAuditRenderer = ({ audit }: Props) => {
  return (
    <div className="fs--1">
      <h3>Value: {audit.displayValue}</h3>
      <MarkdownRenderer content={audit.description} />
    </div>
  );
};

export default NumericAuditRenderer;
